<template>
	<div class="main-table">
		<div class="btn-box">
			<el-button v-if="active === '待处理' && AuthorityList['07_0002_0003_00']" type='primary' plain class="btn fx-btn export-btn" style="margin-left:0;" size="mini" @click="batchAgree()">同意退货</el-button>
			<el-button v-if="active === '待处理' && AuthorityList['07_0002_0003_00']" type='primary' plain class="btn fx-btn export-btn" size="mini" @click="batchReject()">拒绝退货</el-button>
			<el-button v-if="active === '已同意' && AuthorityList['07_0002_0009_00'] && matchbillcenterflag !== 1" type='primary' plain class="btn fx-btn export-btn" style="margin-left:0;" size="mini" @click="batchFinish()">退货完成</el-button>
			<el-button v-if="active === '退货完成' && AuthorityList['07_0002_0016_00']" type='primary' plain class="btn fx-btn export-btn" style="margin-left:0;" size="mini" @click="batchliquidate(1)">勾销</el-button>
			<el-button v-if="active === '退货完成' && AuthorityList['07_0002_0016_00']" type='primary' plain class="btn fx-btn export-btn" size="mini" @click="batchliquidate(0)">取消勾销</el-button>
		</div>
		<div class="main-title-box">
			<div class="main-title1"><el-checkbox v-model="checked" @change="checkALL"></el-checkbox></div>
			<div class="main-title2">收货人信息</div>
			<div class="main-title3">退货数量</div>
			<div class="main-title4">退货金额</div>
			<div class="main-title5">退款方式</div>
			<div class="main-title6">退款类型/原因</div>
			<div class="main-title7">描述</div>
			<div class="main-title8"><span>退单状态</span><i class="el-icon-arrow-down" @click="sortList('0')" v-show="orderSort !== '0'"></i><i class="el-icon-arrow-up" @click="sortList('1')" v-show="orderSort === '0'"></i></div>
			<div class="main-title11">退款状态</div>
			<div class="main-title9">操作</div>
		</div>
		<div class="main-table-box">
			<div class="main-content-box" v-for="(item) in tableData" :key="item.refundid" @dblclick="getDetail(item)">
				<div class="content-title">
					<div class="main-title1" style="flex: 0.12;"><el-checkbox v-model="item.checked" @change='checkSingle'></el-checkbox></div>
					<div class="main-title10">
						<div class="title-name"><span :title="item.customerCategoryName">{{item.customerCategoryName.substring(0,6)}}</span>：<span :title="item.customerName">{{item.customerName.substring(0,10)}}</span></div>
						<div class="title-span">店铺名称：{{item.shopName}}</div>
						<div :title="'退单号：' + item.refundnumber"><span class="title-span">退单：</span>{{item.refundnumber}} <span class="valet" v-if="item.ordersource === 1">代</span></div>
						<div :title="'订单号：' + item.ordernumber"><span class="title-span">订单：</span>{{item.ordernumber}}</div>
						<!-- <div>
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">
									<ul>
										<li v-for="(number, index) in initPaynumber(item.numberArray)" :key="'1' + index">第三方支付流水号：{{number}}</li>
										<li v-for="(number, index) in initPaynumber(item.serialArray)" :key="'2' + index">支付流水号：{{number}}</li>
									</ul>
								</div>
								<span class="title-span">流水号：{{item.paymentnumber ? item.paymentnumber : ''}}</span>
							</el-tooltip>
						</div> -->
						<!-- <div style="display: flex;align-items: center;">
							<span class="title-span">支付流水号：{{item.paymentserialnumber ? item.paymentserialnumber : ''}}</span>
							<el-tooltip class="item" effect="dark" placement="top" v-if="item.paymentserialnumber">
								<div slot="content">
									<ul>
										<li v-for="(number, index) in item.serialArray" :key="index">{{number}}</li>
									</ul>
								</div>
								<img src="~/images/icon/more.png" style="margin-left: 5px;">
							</el-tooltip>
						</div> -->
						<div :title="'申请退单时间：' + item.refundordercreatedate"><span class="title-span">申请退单：</span>{{item.refundordercreatedate}}</div>
						<div :title="'下单时间：' + item.ordercreatedate"><span class="title-span">下单：</span>{{item.ordercreatedate}}</div>
					</div>
				</div>
				<div class="content-content">
					<div class="content-left">
						<!-- <div class="left-main"> -->
							<div class="main-title1"></div>
							<div class="main-title2 main-content2">
								<div class="content-nametel">{{item.buyername}}   {{item.buytel}}</div>
								<div class="content-addr" :title="item.address">{{item.address.substring(0,20)}}</div>
							</div>
							<div class="main-title3 main-content3">
								<div class="content-padding">
									<div>种类：{{item.sumitemcount}}</div>
									<div>数量：{{item.sumrefundquantity}}</div>
								</div>
							</div>
							<div class="main-title4 main-content4"><div class="content-padding">￥{{item.sumrefundmoney}}</div></div>
							<div class="main-title5 main-content5"><div class="content-padding">{{item.paymentmode}}</div></div>
							<div class="main-title6 main-content6"><div class="content-padding">{{item.autorefundflag}} / <span v-if="item.autorefundflag === '自动退单'">单据修改</span><span v-else>{{item.cause}}</span></div></div>
							<div class="main-title7 main-content7"><div class="content-padding" :title="item.memo">{{item.memo.substring(0,20)}}</div></div>
							<div class="main-title8 main-content8">
								<div v-if="item.billState === '0'" class="state-icon state-handle">待处理</div>
								<div v-if="item.billState === '1'" class="state-icon state-agree">已同意</div>
								<div v-if="item.billState === '2'" class="state-icon state-refuse">已拒绝</div>
								<div v-if="item.billState === '3'" class="state-icon state-agree">退货完成</div>
								<div v-if="item.billState === '2'">{{item.cancelCause}}</div>
								<div v-if="item.billState === '3' && item.liquidateflag === 0">未勾销</div>
								<div v-if="item.billState === '3' && item.liquidateflag === 1">已勾销</div>
							</div>
							<div class="main-title11 main-content11">
								<div v-if="item.billState !== '2'">
									<div v-if="item.payStatus === 0" class="state-icon state-handle">待退款</div>
									<div v-if="item.payStatus === 1" class="state-icon state-refuse">退款失败</div>
									<div v-if="item.payStatus === 2" class="state-icon state-agree">退款成功</div>
									<div v-if="item.payStatus === 2 && ( item.initialfinalmoney > +item.backmoney)" style="color: red;margin-left:10px">(抵消)</div>
								</div>
							</div>
							<div class="main-title9">
								<el-button v-if="item.billState === '0' && AuthorityList['07_0002_0003_00']" type='text' size="mini" @click="agreeClick(item)">同意</el-button>
								<el-button v-if="item.billState === '0' && AuthorityList['07_0002_0003_00']" type='text' size="mini" @click="reject(item)">拒绝</el-button>
								<el-button v-if="item.billState === '1' && AuthorityList['07_0002_0009_00'] && matchbillcenterflag !== 1" type='text' size="mini" @click="finish(item)">退货完成</el-button>
								<el-button v-if="item.billState === '3' && item.liquidateflag === 0 && AuthorityList['07_0002_0016_00']" type='text' size="mini" @click="liquidate(item, 1)">勾销</el-button>
								<el-button v-if="item.billState === '3' && item.liquidateflag === 1 && AuthorityList['07_0002_0016_00']" type='text' size="mini" @click="liquidate(item, 0)">取消勾销</el-button>
								<el-button v-if="(item.billState === '0' && (AuthorityList['07_0002_0002_00'] ||AuthorityList['07_0002_0003_00'] )) ||(item.billState === '1' && (AuthorityList['07_0002_0008_00'] || AuthorityList['07_0002_0009_00']))||(item.billState === '2' && (AuthorityList['07_0002_0011_00'] || AuthorityList['07_0002_0012_00'])) ||(item.billState === '3' && (AuthorityList['07_0002_0014_00'] || AuthorityList['07_0002_0015_00']))||(item.billState === '4' && (AuthorityList['07_0002_0005_00'] || AuthorityList['07_0002_0006_00'])) " type='text' size="mini" @click="getDetail(item)">详情</el-button>
							</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
			title="提示"
			:visible.sync="dialogModal"
			:close-on-click-modal="false"
			class="dialog-title"
			width="400px"
			>
				<div style="text-align:center;">
					确认对勾选的{{idsLength}}条订单数据进行批量{{batchType}}处理？
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="cancel2">取 消</el-button>
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="save2">确 定</el-button>
				</span>
		</el-dialog>
		<el-dialog
			title="拒绝原因"
			:visible.sync="rejectModal"
			:close-on-click-modal="false"
			class="dialog-title"
			width="400px"
			>
				<div style="font-size: 17px;text-align: left;">
					确认对勾选的{{idsLength}}条订单数据进行批量{{batchType}}处理？
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="1">质量无问题</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="2">超出退货时间</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="3">问题已解决</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="4">该商品不符合无理由退货</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="5">影响二次销售</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="6">其他原因</el-radio>
				</div>
				<el-input @change='othercauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="cancelcause !==6" type="textarea" v-model="othercauser"></el-input>

				<span slot="footer" class="dialog-footer">
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="cancel11">取 消</el-button>
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="save">确 定</el-button>
				</span>
			</el-dialog>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog class="progress-title" :visible.sync="progressModal" width='500px' :close-on-click-modal="false">
			<Progress :progressModal.sync='progressModal' v-if='progressModal' :keyWord='keyWord' @reload='reload'></Progress>
		</el-dialog>
	</div>
</template>

<script>
import Progress from '@/components/progress/Index.vue'
export default {
	name: 'mainTable',
	components: {
		Progress
	},
	props: {
		active: {
			type: String
		},
		tableData: {
			type: Array
		},
		totalCount: Number,
		clddock: {
			type: Number,
			default: 0
		},
		overrefunddock: {
			type: Number,
			default: 0
		},
		orderSort: {
			type: String
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		}
	},
	data () {
		return {
			othercauser: '',
			AuthorityList: {
				'07_0002_0001_00': false,
				'07_0002_0002_00': false,
				'07_0002_0003_00': false,
				'07_0002_0004_00': false,
				'07_0002_0005_00': false,
				'07_0002_0006_00': false,
				'07_0002_0007_00': false,
				'07_0002_0008_00': false,
				'07_0002_0009_00': false,
				'07_0002_0010_00': false,
				'07_0002_0011_00': false,
				'07_0002_0012_00': false,
				'07_0002_0013_00': false,
				'07_0002_0014_00': false,
				'07_0002_0015_00': false,
				'07_0002_0016_00': false
			},
			rejectModal: false,
			cancelcause: 1,
			refundstatus: null,
			refundstatusid: null,
			refundway: null,
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			checked: false,
			checkedTable: [],
			type: '',
			idsLength: 0,
			matchbillcenterflag: 0,
			batchType: '',
			dialogModal: false,
			progressModal: false,
			keyWord: '',
			liquidateData: {},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'refundid'
			})
		}
	},
	created () {
		this.getAuthority('07_0002_0000_00')
		this.checkSmallCategory()
	},
	methods: {
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		reload () {
			this.$emit('tableReload', true)
		},
		initTableData () {
			let num = 0
			let allSelect = this.tableSelectUtils.getSelectRows()
			console.log(allSelect)
			if (!allSelect || allSelect.length === 0) {
				this.checked = false
				return false
			}
			let allid = allSelect.map((item) => {
				return item.refundid
			})
			this.tableData.forEach(item => {
				if (allid.includes(item.refundid)) {
					num++
					item.checked = true
				} else {
					item.checked = false
				}
			})
			this.checked = num === this.tableData.length
		},
		checkALL (type) {
			let selectArr = []
			let ids = []
			this.tableData.forEach(item => {
				item.checked = type
				if (item.checked) {
					selectArr.push(item)
					ids.push(item.refundid)
				}
			})
			this.tableSelectUtils.selectToggle(this.tableData, selectArr)
			this.$emit('idsChange', ids)
			// console.log(this.tableSelectUtils.getSelectRows())
		},
		checkSingle () {
			let num = 0
			let selectArr = []
			let ids = []
			this.tableData.forEach(item => {
				if (item.checked) {
					num += 1
					selectArr.push(item)
					ids.push(item.refundid)
				}
			})
			this.tableSelectUtils.selectToggle(this.tableData, selectArr)
			this.$emit('idsChange', ids)
			// console.log(this.tableSelectUtils.getSelectRows())
			this.checked = num === this.tableData.length
		},
		sortList (num) {
			this.$emit('sortList', num)
		},
		othercauserChange () {
			this.othercauser = this.othercauser.trim()
			this.othercauser = this.othercauser.replace(/[',\\]/g, '')
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		cancel11 () {
			this.rejectModal = false
		},
		save () {
			let params
			let url
			if (this.type === 'batch') {
				let ids = []
				url = `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus/batch`
				this.tableData.forEach(item => {
					let data = {
						action: 2,
						cancelcause: this.cancelcause,
						refundstatus: parseInt(this.refundstatus),
						refundstatusid: '',
						refundway: '',
						memo: this.othercauser
					}
					if (item.checked) {
						let a = this.payCode(item.paymentmode)
						data.refundstatus = parseInt(item.billState)
						data.refundstatusid = item.statusId
						data.refundway = parseInt(a)
						ids.push(data)
					}
				})
				params = ids
			} else {
				url = `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`
				params = {
					action: 2,
					cancelcause: this.cancelcause,
					refundstatus: parseInt(this.refundstatus),
					refundstatusid: this.refundstatusid,
					refundway: this.refundway,
					memo: this.othercauser
				}
			}
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				this.type = ''
				if (res.result === true) {
					this.clear()
					this.rejectModal = false
					// this.$emit('tableReload', true)
					// this.$message.success('操作成功！')
					// this.$message.success('当前选择' + this.idsLength + '条数据退货处理完成')
					this.keyWord = res.msg
					if (this.type === 'batch') {
						this.progressModal = true
						this.type = ''
					} else {
						this.$emit('tableReload', true)
						this.$message.success('操作成功！')
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		payCode (data) {
			switch (data) {
			case '线下':
				return '0'
			case '商龙钱包':
				return '1'
			case '微信支付':
				return '2'
			case '支付宝':
				return '3'
			case '预付货款':
				return '4'
			case '微企付':
				return '6'
			}
		},
		// 勾销
		liquidate (row, type) {
			let params = {
				liquidateflag: type,
				orderid: row.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('tableReload', true)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		batchliquidate (type) {
			let orderids = ''
			let ids = []
			if (type === 1) {
				this.batchType = '勾销'
			} else if (type === 0) {
				this.batchType = '取消勾销'
			}
			let selectArr = this.tableSelectUtils.getSelectRows()
			selectArr.forEach(item => {
				ids.push(item.refundid)
			})
			this.idsLength = ids.length
			orderids = ids.join(',')
			if (orderids === '' && type === 1) {
				this.$message.warning('请勾选需要勾销的数据！')
				return false
			} else if (orderids === '' && type === 0) {
				this.$message.warning('请勾选需要取消勾销的数据！')
				return false
			}
			let params = {
				liquidateflag: type,
				orderids: orderids
			}
			this.liquidateData = params
			this.dialogModal = true
		},
		finish (val) {
			let a = this.payCode(val.paymentmode)
			let params = {
				action: 3,
				refundstatus: parseInt(val.billState),
				refundstatusid: val.statusId,
				refundway: a
			}
			let msg = '[' + val.refundnumber + ']点击退单成功'
			const logger = this.$fxLogger.createInfo('order.order_detail.editReturn', { msg: msg })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.$message.success('操作成功！')
					this.$emit('tableReload', true)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		batchFinish () {
			let ids = []
			let selectArr = this.tableSelectUtils.getSelectRows()
			selectArr.forEach(item => {
				let data = {
					action: 3,
					refundstatus: this.orderstatus,
					refundstatusid: '',
					refundway: '',
					refundnumber: item.refundnumber
				}
				let a = this.payCode(item.paymentmode)
				data.refundstatus = parseInt(item.billState)
				data.refundstatusid = item.statusId
				data.refundway = parseInt(a)
				ids.push(data)
			})
			this.ids = ids
			if (ids.length === 0) {
				this.$message.warning('请勾选需要处理的数据！')
				return false
			} else {
				this.idsLength = ids.length
				this.batchType = '退货完成'
				this.dialogModal = true
			}
		},
		reject (val) {
			let a = this.payCode(val.paymentmode)
			this.refundstatus = val.billState
			this.refundstatusid = val.statusId
			this.refundway = a
			this.cancelcause = 1
			this.rejectModal = true
		},
		batchReject () {
			let ids = []
			let selectArr = this.tableSelectUtils.getSelectRows()
			selectArr.forEach(item => {
				ids.push(item)
			})
			if (ids.length === 0) {
				this.$message.warning('请勾选需要处理的数据！')
				return false
			} else {
				this.idsLength = ids.length
				this.batchType = '拒绝'
				this.rejectModal = true
				this.type = 'batch'
			}
		},
		agreeClick (val) {
			let a = this.payCode(val.paymentmode)
			let params = {
				action: 1,
				refundstatus: parseInt(val.billState),
				refundstatusid: val.statusId,
				refundway: parseInt(a)
			}
			let msg = '[' + val.refundnumber + ']点击同意退单'
			const logger = this.$fxLogger.createInfo('order.order_detail.editReturn', { msg: msg })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.$message.success('操作成功！')
					this.$emit('tableReload', true)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		batchAgree () {
			this.batchType = '同意'
			let ids = []
			let selectArr = this.tableSelectUtils.getSelectRows()
			selectArr.forEach(item => {
				let data = {
					action: 1,
					refundstatus: this.orderstatus,
					refundstatusid: '',
					refundway: '',
					refundnumber: item.refundnumber
				}
				let a = this.payCode(item.paymentmode)
				data.refundstatus = parseInt(item.billState)
				data.refundstatusid = item.statusId
				data.refundway = parseInt(a)
				ids.push(data)
			})
			this.idsLength = ids.length
			this.ids = ids
			if (this.idsLength === 0) {
				this.$message.warning('请勾选需要处理的数据！')
				return false
			} else {
				this.dialogModal = true
			}
		},
		saveBatchLiquidate (type) {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/liquidateflag/batch`,
				data: this.liquidateData
			}).then(res => {
				if (res.result) {
					// this.$message.success(res.msg)
					this.clear()
					this.$message.success('当前选择' + this.idsLength + '条数据全部' + type)
					this.dialogModal = false
					this.$emit('tableReload', true)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		saveBatchAgree (val) {
			let msg = this.ids.map(item => {
				return ('[' + item.refundnumber + ']')
			})
			const logger = this.$fxLogger.createInfo('order.order_detail.editReturn', { msg: msg.join(',') + '点击' + val })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus/batch`,
				data: this.ids,
				logger
			}).then(res => {
				if (res.result === true) {
					this.clear()
					// this.$message.success('当前选择' + this.idsLength + '条数据退货处理完成')
					this.dialogModal = false
					// this.$emit('tableReload', true)
					this.keyWord = res.msg
					this.progressModal = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		save2 () {
			if (this.batchType === '同意') {
				this.saveBatchAgree('同意退单')
			} else if (this.batchType === '退货完成') {
				this.saveBatchAgree('退单成功')
			} else if (this.batchType === '勾销') {
				this.saveBatchLiquidate(this.batchType)
			} else if (this.batchType === '取消勾销') {
				this.saveBatchLiquidate(this.batchType)
			}
		},
		cancel2 () {
			this.dialogModal = false
			this.batchType = ''
		},
		btnClick (data) {
			let params = {
				action: data,
				refundstatus: this.orderstatus,
				refundstatusid: this.refundstatusid,
				refundway: this.refundway
			}
			if (data === 2) {
				params.cancelcause = this.cancelcause
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$message.success('操作成功！')
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getDetail (value) {
			this.$emit('saveSelect')
			this.$router.push({ path: 'refundOrderDetail' })
			let a = JSON.stringify(value)
			window.sessionStorage.setItem('refundOrderParams', a)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		},
		initPaynumber (value) {
			return new Set(value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	.btn-box {
		width: 80px;
		display: flex
		justify-content: start;
		padding: 10px 0
	}
	.radio{
		text-align :left
		margin :10px 0px 10px 10px
	}
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	// height: 100%
	// .main-table-box {
	// 	flex: 1
	// 	padding-bottom 10px
	// 	overflow-y: auto;
	// }
	.main-title-box {
		width: 100%;
		height: 50px;
		line-height: 50px;
		color: #333;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		background-color: #F7F8FA
		div{
			text-align: center
			font-weight: bold
		}
	}
	.main-title1 {
		flex: 1
	}
	.main-title2 {
		flex: 5
	}
	.main-title3 {
		flex: 3
	}
	.main-title4 {
		flex: 3
	}
	.main-title5 {
		flex: 2
	}
	.main-title6 {
		flex: 4
	}
	.main-title7 {
		flex: 4
	}
	.main-title8 {
		flex: 4
		i {
			padding-left: 10px
			cursor: pointer
		}
	}
	.main-title9 {
		flex: 5
	}
	.main-title11 {
		flex: 4
		i {
			padding-left: 10px
			cursor: pointer
		}
	}
	.main-title10 {
		flex: 4
		display: flex
		justify-content: space-between;
		padding-right: 5%;
		padding-left: 15px;
		div {
			overflow: hidden;
			text-overflow: ellipsis;
			// white-space: nowrap;
			word-break: break-all;
			word-wrap: break-word;
		}
		.title-name {
			font-size: 15px;
			font-weight: bold
		}
		.title-span {
			color: #595959
		}
		.valet {
			display: inline-block;
			width: 16px;
			height: 16px;
			line-height: 16px;
			border: 1px solid #f38e0b;
			border-radius: 4px;
			color: #f38e0b;
			font-size: 10px;
			-webkit-transform: scale(0.9);
			transform: scale(0.9);
			margin-left: 3px;
		}
	}
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.main-content-box {
			width: 100%;
			color: #333;
			font-size: 14px;
			border: 1px solid #EDEFFC;
			box-shadow: 0px 2px 4px 1px rgba(199, 199, 199, 0.23);
			box-sizing: border-box;
			border-radius: 2px;
			margin-top: 10px
			&:hover {
				border: 1px solid var(--fx-primary-color)
			}
			.content-title {
				width: 100%
				height: 60px;
				line-height: 60px;
				background-color: #F0F3FA
				display: flex;
			}
			.content-content {
				display: flex
				.content-left {
					flex:1;
					display:flex
					color: #333
					// flex-direction: column
					&>div{
						display: flex
						justify-content: center;
						align-items: center;
						padding: 15px 0
						border-right: 1px solid #edeffc;
						&:first-of-type, &:last-of-type {
							border-right: 0
						}
						&.main-content2 {
							flex-direction: column;
							text-align: left;
							.content-nametel {
								width: 100%;
								color: #666;
								font-weight: bold
								padding-right: 10px;
								box-sizing: border-box;
							}
							.content-addr {
								width: 100%;
								color: #999
								padding-right: 10px;
								box-sizing: border-box;
							}
						}
						&.main-content3, &.main-content8, &.main-content11 {
							flex-direction: column;
						}
						&.main-content4 {
							font-size: 16px
							font-weight: bold
						}
						.content-padding {
							width: 100%;
							padding: 0 15px;
							box-sizing: border-box;
						}
					}
					.state-icon {
						width: 59px;
						height: 26px;
						line-height: 27px;
						font-weight: bold;
						border-radius: 4px;
						font-size: 13px;
						margin-bottom: 8px;
					}
					.state-handle {
						background: rgba(236, 65, 65, 0.15)
						color: #EC4141
					}
					.state-agree {
						background: rgba(61, 168, 28, 0.15)
						color: #3DA81C
					}
					.state-refuse {
						background: rgba(102, 102, 102, 0.15)
						color: #666
					}
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.main-table {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__footer{
		text-align :center
	}
}
</style>
